import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { bolepidemiologicos2026TNE } from "../../../../json/bolepid2026TNE.js";

const TNE2026 = () => {
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Boletín Epidemiológico Trimestral - TNE</h1>
          </div>
        </div>
      </div>
      <div className="col-md-12 col-sm-12 col-12" >      
        <hr class="hr-gob"></hr>
        {/* <h2>{itemint.informacion_grupo}</h2> */}
          <div className="links-informacion">
            <ul>
              {bolepidemiologicos2026TNE.map((itemint, i) => (                          
              <div>
                <li>      
                  <Link target="_blank" to={itemint.url_elemento}>
                    {itemint.etiqueta_elemento}                      
                  </Link>     
                </li>                      
              </div>       
              ))}
            </ul>
          </div>          
        </div>
    </div>
  );
};

export default TNE2026;
